var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { QuerySpaceGroupPermissionRepository, UpdateSpaceGroupPermissionRepository } from './space-group-permission-repository.interface';
let SpaceGroupPermissionServiceImpl = class SpaceGroupPermissionServiceImpl {
    constructor(_updateSpaceGroupPermissionRepository, _querySpaceGroupPermissionRepository) {
        this._updateSpaceGroupPermissionRepository = _updateSpaceGroupPermissionRepository;
        this._querySpaceGroupPermissionRepository = _querySpaceGroupPermissionRepository;
    }
    updateSpaceGroupPermissions(spaceId, permissions) {
        return this._updateSpaceGroupPermissionRepository.updateSpaceGroupPermissions(spaceId, permissions);
    }
    querySpaceGroupPermissions(spaceId) {
        return this._querySpaceGroupPermissionRepository.querySpaceGroupPermissions(spaceId);
    }
};
SpaceGroupPermissionServiceImpl = __decorate([
    injectable(),
    __param(0, inject(UpdateSpaceGroupPermissionRepository)),
    __param(1, inject(QuerySpaceGroupPermissionRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof UpdateSpaceGroupPermissionRepository !== "undefined" && UpdateSpaceGroupPermissionRepository) === "function" ? _a : Object, typeof (_b = typeof QuerySpaceGroupPermissionRepository !== "undefined" && QuerySpaceGroupPermissionRepository) === "function" ? _b : Object])
], SpaceGroupPermissionServiceImpl);
export { SpaceGroupPermissionServiceImpl };
